import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class OrderTemplate extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/order/template`)
  }

  detail(orderTemplateId, showProgress) {
    return this._request({
      action: `${orderTemplateId}/detail`,
      method: 'GET',
      showProgress
    })
  }
}
